import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function regexable(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    try {
      new RegExp(control.value);
    } catch(e) {
      return {
        regexable: e.message.replace(`Invalid regular expression: /${control.value}/:`, '')
      };
    }
    return null;
  }
}
